import { render, staticRenderFns } from "./ProductCardDisplay.vue?vue&type=template&id=489a474c&"
import script from "./ProductCardDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductCardDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports